var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFullscreenIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M453 38H59C47.402 38 38 47.402 38 59V453C38 464.598 47.402 474 59 474H453C464.598 474 474 464.598 474 453V59C474 47.402 464.598 38 453 38ZM59 0C26.4152 0 0 26.4152 0 59V453C0 485.585 26.4152 512 59 512H453C485.585 512 512 485.585 512 453V59C512 26.4152 485.585 0 453 0H59ZM117 142L204 227L230.5 197.5L145 111.5H196.5V75H78V191.5H117V142ZM229.439 304.366L145.97 392.837L195.463 391.973L196.143 430.967L79.6611 433L77.593 314.518L114.087 313.881L114.986 365.373L199.481 278.385L229.439 304.366ZM367.987 114.74L282.231 200.995L311.499 227.752L398.242 143.006L397.792 194.504L434.291 194.822L435.325 76.3267L318.83 75.31L318.489 114.309L367.987 114.74ZM309.5 280L396.5 365V315.5H435.5V432H317V395.5H368.5L283 309.5L309.5 280Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullscreenIcon);
export default __webpack_public_path__ + "static/media/fullscreen-icon.66b1d000.svg";
export { ForwardRef as ReactComponent };